module.exports = __webpack_public_path__ + "static/app/img/top_bg.c21adaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/top_bg.png
// module id = Yru/
// module chunks = 1